const tokenProject = [
    {
      title: "Tokenización de Activos con Prueba de Título",
      value: `Este proyecto tiene como finalidad ayudarte a crear y lanzar un token de seguridad o de activo (Security/Asset Token) respaldado por bienes reales o derechos contractuales, utilizando la blockchain de Ethereum. Aquí seguirás un proceso paso a paso para desarrollar un caso práctico, desde la idea hasta su despliegue en red.
  
  ---
  
   **¿Qué haremos exactamente?**
  
  Imagina que tienes una propiedad valorada en $1,000,000 USD y deseas recaudar $400,000 sin acudir a métodos tradicionales como bancos. Gracias a la tokenización, puedes dividir este inmueble en 1,000,000 tokens. Cada token representará el 0.0001% del activo. Los compradores podrán adquirir esos tokens, y tú podrás fondear tu proyecto con facilidad, manteniendo el control del proceso desde tu wallet.
  
  ---
  
   **Etapas del Proyecto**
  
  1. **Prueba de Título y Selección del Activo**
     - Analizarás si el activo es apto para ser tokenizado.
     - Prepararás un contrato fuera de la cadena (off-chain) que respalde legalmente los derechos sobre el activo.
     - Ejemplos incluidos: propiedad inmobiliaria, película, equipo deportivo o empresa extractiva.
  
  2. **Edición de Contrato Inteligente**
     - Descargarás una plantilla de smart contract (formato ERC20 adaptado).
     - Insertarás tu nombre, símbolo del token, cantidad total y vínculo con la prueba de título.
     - Personalizarás funciones como la tasa de conversión ETH/token y distribución inicial.
  
  3. **Compilación y Bytecode**
     - Compilarás el contrato usando Remix IDE.
     - Extraerás el bytecode necesario para el despliegue.
     - Harás pequeñas modificaciones si necesitas incluir cláusulas adicionales.
  
  4. **Despliegue en la Testnet (Sepolia)**
     - Crearás tu wallet en MyEtherWallet (MEW).
     - Solicitarás ETH de prueba desde un faucet Sepolia.
     - Insertarás el bytecode en MEW y desplegarás el contrato.
     - Confirmarás las transacciones en el blockchain usando Etherscan.
  
  5. **Verificación y Publicación**
     - Verificarás tu contrato en Ropsten para mostrar el código fuente.
     - Opcionalmente, podrás repetir el proceso en la red principal de Ethereum.
  
  ---
  
   **Qué recibirás**
  
  - Un contrato inteligente funcional para tokenizar activos físicos o intangibles.
  - Contratos off-chain de ejemplo (real estate, cine, deportes y minería).
  - Una guía clara para establecer el valor de tus tokens.
  - Instrucciones para editar tu contrato en Remix y desplegarlo desde MEW.
  - Acceso al código original editable y compatible con múltiples proyectos.
  
  ---
  
   **Aplicaciones prácticas**
  
  - Fraccionar propiedades inmobiliarias y vender participaciones.
  - Financiar películas o videojuegos mediante tokens respaldados por derechos.
  - Tokenizar regalías de artistas, propiedades intelectuales o participaciones de empresas.
  - Emisión de bonos digitales o instrumentos de deuda convertibles.
  
  ---
  
   **Consideraciones legales**
  
  Este proyecto incluye un apartado claro sobre qué es la prueba de título, su importancia y cómo debe adjuntarse al contrato inteligente o mantenerse como respaldo legal fuera de la cadena. No se necesita formación legal, el lenguaje es claro, práctico y sin tecnicismos.
  
  
  
  **Objetivo final**
  
  Al concluir este proyecto, habrás creado tu propio token de seguridad o activo, desplegado un contrato inteligente funcional en Ethereum y comprendido los fundamentos técnicos y legales para tokenizar valor real desde cero. Podrás reutilizar el modelo para futuros proyectos.
  
  Este enfoque ha sido probado exitosamente en más de 115 tokens lanzados siguiendo esta misma metodología.`,
    },
  ];
  
  export default tokenProject;
  